import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import * as constants from "../../Components/constants";
import { useRouter } from "next/router";
import Swal from "sweetalert2";

const EmailVerify = () => {
  const [email, setEmail] = useState("");

  const router = useRouter();
  const baseURL = constants.BASE_URL;

  // login function
  const loginHeader = {
    mode: "cors",
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
      password: "",
    }),
  };

  const handleLogin = (event) => {
    event.preventDefault();

    fetch(`${baseURL}/user/signin`, loginHeader)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data?.is_active) {
          window.localStorage.setItem("id", data.data.id);
          window.localStorage.setItem("first_name", data.data.first_name);
          window.localStorage.setItem("last_name", data.data.last_name);
          window.localStorage.setItem("email", data.data.email);
          window.localStorage.setItem("auth_token", data.data.token);
          router.push(`/user/${localStorage.id}`);
        } else if (data.verified === false) {
          Swal.fire({
            title: "sending verification code",
            html: "The code has been sending to your email",
            timer: 3000,
            timerProgressBar: true,
          });
          router.push("/user/verification");
        }
      })
      .catch((error) => {
        Swal.fire({
          title: "You don't have any account. Please Create a account.",
          icon: "warning",
          confirmButtonColor: "#ff0000",
          confirmButtonText: "Ok",
        });
      });
  };

  return (
    <Container>
      <Row className="justify-content-center">
        <Col
          md={5}
          className="d-flex justify-content-center align-items-center"
          style={{ height: "90vh" }}
        >
          <form
            onSubmit={handleLogin}
            className="form-group form-box p-3 shadow-lg"
          >
            <div className="d-flex flex-column justify-content-center align-items-center py-3">
              <label className="fs-4 fw-bold">Verify Your Email Address</label>
              <span className="text-muted">
                To continue using research rider, please verify your email
                address
              </span>
            </div>
            <input
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="email"
              className="form-control"
              placeholder="Enter email address"
              required
            />
            <small id="emailHelp" className="form-text text-muted">
              We&apos;ll never share your email with anyone else.
            </small>

            <div className="text-center">
              <Button
                className="px-4 my-2"
                variant="success"
                size="sm"
                type="submit"
              >
                Verify
              </Button>
            </div>
          </form>
        </Col>
      </Row>
    </Container>
  );
};

export default EmailVerify;
